import { useRef } from 'react';

import { App } from 'antd';

import Layout from '../../../components/Layout/Layout';
import RoleFilters from './components/RoleFilters';
import RoleModals from './components/RoleModals';
import RoleTable from './components/RoleTable';
import { useRoleMetadata } from './hooks/useRoleMetadata';
import { useRoleModals } from './hooks/useRoleModals';
import { useRoleTable } from './hooks/useRoleTable';
import { RoleModalHandlers } from './types';

import './Roles.scss';

function Roles() {
  const { message } = App.useApp();

  const modalHandlersRef = useRef<RoleModalHandlers>({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openDetailModal: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openMenuDetailModal: () => {},
  });

  const metadata = useRoleMetadata({ message });

  const table = useRoleTable({
    message,
    setTableLoading: metadata.setTableLoading,
    modalHandlers: modalHandlersRef.current,
  });

  const modals = useRoleModals({
    message,
    fetchDataFromServer: table.fetchDataFromServer,
    setTableLoading: metadata.setTableLoading,
  });

  // Sincronizar los handlers reales tras cada render
  modalHandlersRef.current = {
    openDetailModal: modals.openDetailModal,
    openMenuDetailModal: modals.openMenuDetailModal,
  };

  return (
    <Layout title={''}>
      <RoleFilters
        tableLoading={metadata.tableLoading}
        onSearch={table.onSearch}
        onCreateRole={modals.openNewRoleModal}
      />
      <RoleTable table={table} tableLoading={metadata.tableLoading} />
      <RoleModals
        modals={modals}
        campaigns={metadata.campaigns}
        kitIntegrationEnabled={metadata.kitIntegrationEnabled}
        tiendaPerfectaIntegrationEnabled={
          metadata.tiendaPerfectaIntegrationEnabled
        }
        tiendaPerfectaDistributors={metadata.tiendaPerfectaDistributors}
        tiendaPerfectaDistributorsLoading={
          metadata.tiendaPerfectaDistributorsLoading
        }
      />
    </Layout>
  );
}

export default Roles;
